<template>
  <div
    class="relative shrink-0 min-w-0 w-full sm:w-56 md:w-64 lg:w-[17.5rem]"
  >
    <input
      :value="modelValue"
      type="search"
      class="w-full h-10 text-sm transition bg-white/90 border rounded-xl dark:bg-slate-900/80 border-slate-200/80 dark:border-slate-700/80 text-slate-700 dark:text-slate-200 placeholder:text-slate-400 shadow-sm shadow-slate-200/40 dark:shadow-none hover:border-primary/30 focus:outline-none focus:border-primary/50 focus:ring-2 focus:ring-primary/15"
      :class="lang === 'ar' ? 'pr-9 pl-8' : 'pl-9 pr-8'"
      :placeholder="placeholder"
      :title="ariaLabel || placeholder"
      :aria-label="ariaLabel || placeholder"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <i
      class="absolute text-[17px] -translate-y-1/2 mdi mdi-magnify text-slate-400 pointer-events-none"
      :class="
        lang === 'ar' ? 'right-3 left-auto top-1/2' : 'left-3 right-auto top-1/2'
      "
    ></i>
    <button
      v-if="modelValue"
      type="button"
      class="absolute -translate-y-1/2 flex items-center justify-center w-6 h-6 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
      :class="
        lang === 'ar' ? 'left-2 right-auto top-1/2' : 'right-2 left-auto top-1/2'
      "
      :title="clearTitle"
      @click="$emit('clear')"
    >
      <i class="mdi mdi-close text-[14px]"></i>
    </button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, default: "" },
  lang: { type: String, default: "ar" },
  placeholder: { type: String, required: true },
  ariaLabel: { type: String, default: "" },
  clearTitle: { type: String, default: "Clear" },
});

defineEmits(["update:modelValue", "clear"]);
</script>
